// extracted by mini-css-extract-plugin
module.exports = {"p":"G8zE4Sc_enWewtpN6-AMa"};